import { useSearchParams } from 'react-router-dom';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { SECONDARY_MARKET_URL_BY_SPORT } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { navLabels } from '@sorare/core/src/lib/glossary';

export const MarketHeader = () => {
  const [searchParams] = useSearchParams();
  const previousParams = searchParams.get('previousParams');

  const { sport } = useSportContext();
  const marketBaseUrl = SECONDARY_MARKET_URL_BY_SPORT[sport || Sport.FOOTBALL];
  const marketUrl =
    previousParams === null
      ? undefined
      : `${marketBaseUrl}${previousParams || ''}`;

  return (
    <PageHeader
      text={marketUrl ? undefined : navLabels.market}
      backTo={marketUrl}
      disableBackBrowser
    />
  );
};
